import * as React from "react";
function SvgDiscoveryHeroMagicWand(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={76}
      height={76}
      fill="none"
      ref={svgRef}
      {...props}
    >
      <path
        fill="#F1FFFD"
        d="M76 38c0 20.987-17.013 38-38 38S0 58.987 0 38 17.013 0 38 0s38 17.013 38 38z"
      />
      <path
        fill="#28BBBB"
        fillRule="evenodd"
        d="M41.63 26.334a2.134 2.134 0 013.022 0l4.992 5.035a2.134 2.134 0 010 3.022L24.662 59.373a2.134 2.134 0 01-3.022 0l-5.013-5.013a2.134 2.134 0 010-3.021L41.63 26.334zm1.5 1.243a.75.75 0 01.531.22l4.542 4.542a.75.75 0 010 1.06l-5.228 5.229a.75.75 0 01-1.06 0l-4.543-4.543a.75.75 0 010-1.06l5.228-5.228a.75.75 0 01.53-.22zm6.715 12.693a.625.625 0 01.747-.104l5.052 2.829 5.05-2.83a.625.625 0 01.851.852l-2.828 5.05 2.828 5.052a.625.625 0 01-.85.85l-5.051-2.828-5.052 2.829a.625.625 0 01-.85-.851l2.828-5.051-2.828-5.051a.625.625 0 01.103-.748zm2.07 2.07l1.917 3.422a.625.625 0 010 .611l-1.917 3.423 3.423-1.917a.625.625 0 01.61 0l3.424 1.917-1.917-3.423a.625.625 0 010-.61l1.917-3.424-3.423 1.917a.625.625 0 01-.61 0l-3.424-1.917zm-2.07-27.782a.625.625 0 01.747-.103l5.052 2.828 5.05-2.828a.625.625 0 01.851.85l-2.828 5.052 2.828 5.05a.625.625 0 01-.85.851l-5.051-2.828-5.052 2.828a.625.625 0 01-.85-.85l2.828-5.052-2.828-5.05a.625.625 0 01.103-.748zm2.07 2.07l1.917 3.423a.625.625 0 010 .61l-1.917 3.424 3.423-1.917a.625.625 0 01.61 0l3.424 1.917-1.917-3.423a.625.625 0 010-.61l1.917-3.424-3.423 1.917a.625.625 0 01-.61 0l-3.424-1.917zm-27.781-2.07a.625.625 0 01.747-.103l5.051 2.828 5.051-2.828a.625.625 0 01.851.85l-2.829 5.052 2.83 5.05a.625.625 0 01-.852.851l-5.05-2.828-5.052 2.828a.625.625 0 01-.85-.85l2.828-5.052-2.829-5.05a.625.625 0 01.104-.748zm2.07 2.07l1.917 3.423a.625.625 0 010 .61l-1.917 3.424 3.423-1.917a.625.625 0 01.61 0l3.424 1.917-1.917-3.423a.625.625 0 010-.61l1.917-3.424-3.423 1.917a.625.625 0 01-.611 0l-3.423-1.917z"
        clipRule="evenodd"
      />
    </svg>
  );
}
const ForwardRef = React.forwardRef(SvgDiscoveryHeroMagicWand);
const MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;
